import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { client } from 'common/repositories';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { UserModel } from './model';

const ENDPOINT = 'me';

export function useGetMe(
  options?: UseQueryOptions<ApiResult<UserModel>, ApiError>,
): UseQueryResult<ApiResult<UserModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['get-me'],
      () =>
        QueryFetchFunction({
          url: ENDPOINT,
        }),
      {
        staleTime: Infinity,
        cacheTime: Infinity,
        ...options,
      },
    ),
    UserModel,
  );
}

export function useGetPermissions(
  options?: UseQueryOptions<ApiResult<string[]>, ApiError>,
): UseQueryResult<ApiResult<string[]>, ApiError> {
  return useQuery(
    ['get-permissions'],
    () =>
      QueryFetchFunction({
        url: `${ENDPOINT}/permissions`,
      }),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      ...options,
    },
  );
}

export const getMe = async function (): Promise<UserModel> {
  const response = await client.get('me').json<ApiResult<UserModel>>();
  return response.data;
};

export const getPermission = async function (): Promise<string[]> {
  const response = await client
    .get('me/permissions')
    .json<ApiResult<string[]>>();
  return response.data;
};
